import { MagicCopyPermission, ModelType } from '@biteinc/enums';
import { enterpriseTagSchema } from '@biteinc/schemas';

app.EnterpriseTag = app.AbstractModel.extend({
  ModelName: 'enterpriseTag',
  Schema: enterpriseTagSchema,
  Type: ModelType.EnterpriseTag,

  url() {
    return `/api/v2/enterprise-tags/${this.id || ''}`;
  },

  getFieldCollection(field, _subProperty, _includeAllValues, _keyModel) {
    switch (field) {
      case 'magicCopyPermission':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: MagicCopyPermission,
          nameGenerator: (permission) => {
            switch (permission) {
              case MagicCopyPermission.ConfigurationOnly:
                return 'Configuration only';
              case MagicCopyPermission.ConfigurationAndMenu:
                return 'Configuration and menu';
            }
          },
        });
    }
    return null;
  },
});
